import { FC } from 'react'
import { PARENT_TAB, VIEWS } from '../constants'
import { useLogisticBox } from '../context/LogisticBoxContext'

const TabsNav: FC = () => {
  const { activeView, setActiveView } = useLogisticBox()
  const activeTab = PARENT_TAB[activeView]
  return (
    <div className='flex items-center gap-2 flex-wrap'>
      {VIEWS.map(v => {
        const active = activeTab === v.key
        return (
          <button
            key={v.key}
            onClick={() => setActiveView(v.key)}
            className={`rounded-[10px] px-4 py-2 text-[13px] font-medium transition-all ${
              active
                ? 'bg-[#e8eaf5] text-[#151930] font-semibold'
                : 'text-gray-500 hover:text-[#151930]'
            }`}
          >
            {v.label}
          </button>
        )
      })}
    </div>
  )
}

export default TabsNav
